export { YUNXIN_NONE_SENTINEL } from '@/api/logical/contact_constants';
export var StaticNodeKey;
(function (StaticNodeKey) {
    StaticNodeKey["PERSON"] = "person";
    StaticNodeKey["PERSON_ALL"] = "personal_all";
    StaticNodeKey["PERSON_NO_GROUP"] = "personal_no_group";
    StaticNodeKey["PERSON_MARK_LIST"] = "personal_mark_list";
})(StaticNodeKey || (StaticNodeKey = {}));
export const contactDbName = 'contact_dexie';
export const contactSearchDbName = 'contact_search';
export const edmcontactSearchDbName = 'edm_contact_search';
export const contactCustomerGlobalDBName = 'contact_global';
export const contactCustomerDBName = 'contact_customer';
export const contactTable = 'contact';
export const contactItemTable = 'contactItem';
export const orgContactTable = 'orgContact';
export const orgManager = 'orgManager';
export const orgTable = 'org';
export const recentContactTable = 'recent_contact';
export const personalMarkTable = 'personal_mark';
export const orgpathlistTable = 'orgpathlist';
export const frequentContactTable = 'frequentContact';
export const lxInfoTable = 'lx_info';
export const orgTableHitList = ['orgName', 'orgPYName'];
export const contactTableHitList = [
    ['contact', 'contactName'],
    ['contact', 'contactPYName'],
    ['contact', 'contactPYLabelName'],
];
export const CustomerContactSearchHitList = ['contactName', 'contactPYName', 'contactPYLabelName'];
export const contactItemTableHitList = [['contactInfo', 'contactItemVal']];
export const colors = ['#6BA9FF', '#70CCAB', '#AA90F4', '#F7A87C'];
export const searchTableLimit = 1000;
export const searchResultDisplayLimit = 50;
export const LOCAL_ENTERPRISE_SKIP_THRESHOLD = 30;
export const statusLevel = {
    5: 1,
    6: 2,
    4: 3,
    1: 4,
    2: 5,
    3: 6,
    other: 7,
};
export const lastSyncTimeKeyMap = {
    enterprise: 'server_sync_enterprise_last_time_',
    client: 'client_sync_last_time_',
    personal: 'server_sync_personal_last_time_',
    org: 'server_sync_org_last_time_',
    personalOrg: 'server_sync_personal_org_last_time_',
};
export const getLastSyncTimeKey = (key) => lastSyncTimeKeyMap[key];
